const coinFeatureData = [
    {
        category: 'Explore',
        description: 'Travel to new tiles and uncover hidden rewards in the ground beneath your feet!',
        howTo3Steps: [
            'Click the Geomine Button at the bottom of your COIN App',
            'Wait for the Geomine complete',
            'Your COIN from that Geomine is automatically collected and added to your total!',
        ],
        howToTitle: 'How to Geomine',
        id: 'geomine',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360033279773',
        learnMoreDescription: 'Similar to Geocaching, Geomining is the act of locating and discovering valuable digital items or assets from a real, physical space. COIN allows you to travel to new tiles, Geomine, and uncover hidden rewards in the ground beneath your feet! With those digital rewards, you can compete and interact with other users, or even transform them into real-world items!',
        name: 'Geomine',
        relatedFeatures: ['big-geomines', 'geomining-recharge', 'geomining-speed', 'extension-devices'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Sometimes the surprises come from above. Be sure to pick them up!',
        howTo3Steps: [
            'Click the Geodrop Button at the bottom of your COIN App',
            'Select how much COIN you want to Geodrop',
            'Confirm your Geodrop!',
        ],
        howToTitle: 'How to Geodrop',
        id: 'geodrop',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360032812094',
        learnMoreDescription: 'A Geodrop allows you to drop a digital asset (such as the COIN you discover) on the tile you’re standing on. When a user Geomines that same tile with COIN App, they’ll collect your reward! You can also send email-specific Geodrops, so they are the only users who can pick up the rewards!',
        name: 'Geodrop',
        relatedFeatures: ['Remote Geodrop'],
        video: 'https://www.youtube.com/watch?v=CVWRI27mV7M&t=119s',
    },
    {
        category: 'Socialize',
        description: 'Certain regions in COIN are more popular and rewarding than others. Claim a region weekly, and compete with other users!',
        howTo3Steps: [
            'Click the Geoclaim Button at the bottom of your COIN App',
            'Click the +COIN button to add COIN to this Geoclaim tile',
            'Watch throughout the week to see ownership change and rewards come in!',
        ],
        howToTitle: 'How to Geoclaim',
        id: 'geoclaim',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360033267574',
        learnMoreDescription: '',
        name: 'Geoclaim',
        relatedFeatures: ['remote-geoclaim', 'geomine'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Look Ma! No Hands! Driving, running, or doing something else that needs your full attention? Simply turn on Auto Explore (formerly Auto Collect).',
        howTo3Steps: [
            'Turn on the Auto Explore button below the Geomine Button',
            'If the button is green, Auto Explore is Active!',
            'Auto Explore simply needs a fresh tile to work. Great for driving!',
        ],
        howToTitle: 'How to Turn on Auto Explroe',
        id: 'auto-explore',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360032771174',
        learnMoreDescription: '',
        name: 'Auto Explore',
        relatedFeatures: ['geomine', 'geomining-speed'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Sometimes it feels good to have a night in. Establish a Home Base, and enjoy COIN from home.',
        howTo3Steps: [
            'Geomine 3 times in a row, in the same tile to establish a Home Base',
            'You will see a Home Base Icon appear!',
            'Home Base will cap at 100% boost (or 9 hours) and resets every 24 hours.',
        ],
        howToTitle: 'How to Set Up Home Base',
        id: 'home-base',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360044676394',
        learnMoreDescription: '',
        name: 'Home Base',
        relatedFeatures: ['geeomine', 'auto-explore'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Play in-store rewarded scavenger hunts while learning about new products.',
        howTo3Steps: [
            "Click the '+' menu in the top right",
            'Tap Rewarded Tasks, and then Product Scans.',
            'See available Product Scans near you, and follow the on-screen instructions.',
        ],
        howToTitle: 'How to Complete Product Scans',
        id: 'product-scans',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360058812333',
        learnMoreDescription: '',
        name: 'Product Scans',
        relatedFeatures: ['store-visits', 'engaging-surveys'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Get special offers, deals, coupons, and rewards while visiting popular stores',
        howTo3Steps: [
            "Click the '+' menu in the top right",
            'Tap Rewarded Tasks, and then Store Visits.',
            'See available Store Visits near you, and follow the on-screen instructions.',
        ],
        howToTitle: 'How to Complete Store Visits',
        id: 'store-visits',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360058812313',
        learnMoreDescription: '',
        name: 'Store Visit',
        relatedFeatures: ['engaging-surveys', 'product-scans'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Make your voice heard. Contribute your opinions and help the world around you!',
        howTo3Steps: [
            "Click the '+' menu in the top right",
            'Tap Rewarded Tasks, and then Rewarded Surveys.',
            'See available Rewarded Surveys near you, and follow the on-screen instructions.',
        ],
        howToTitle: 'How to Complete Rewarded Surveys',
        id: 'engaging-surveys',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360042771634',
        learnMoreDescription: '',
        name: 'Rewarded Surveys',
        relatedFeatures: ['store-visits', 'product-scans'],
        video: '',
    },
    {
        category: 'Socialize',
        description: "You're an experienced COIN user. Help a new player get started, and you'll get something in return!",
        howTo3Steps: [
            "Click the '+' menu in the top right",
            ' Tap the "Referral Rewards" button',
            'Tap the unique "Invite link" to copy your link. Text it, email it, or share it on social media.',
        ],
        howToTitle: 'How to Use Your Referral Link',
        id: 'referral-links',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360034676253',
        learnMoreDescription: '',
        name: 'Referral Links',
        relatedFeatures: ['geoclaim', 'team-lift'],
        video: '',
    },
    {
        category: 'Socialize',
        description: 'Nothing can stand in the way of a group of serious, seasoned COIN players. Work together to discover additional rewards. ',
        howTo3Steps: [
            'If premium users Geomine near each other, a team lift indicator will appear. ',
            'Each one is worth 10% more on each Geomine with a max of 100%.',
            'We hope you enjoy this new bonus and start Geomining with your friends.',
        ],
        howToTitle: 'How to Activate Team Lift',
        id: 'team-lift',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360044376133',
        learnMoreDescription: '',
        name: 'Team Lift',
        relatedFeatures: ['geomine', 'subscriptions'],
        video: '',
    },
    {
        category: 'Explore',
        description: "Sometimes you may forget to explore the amazing world of COIN, but we've got your back (for a bit!) with Background Rewards.",
        howTo3Steps: [
            'Background Rewards automatically start anytime you leave COIN app.',
            'Rewards will collect for 3-9 hours after leaving.',
            'To earn the most out of Background Rewards, change Background location permissions to "Always On" ',
        ],
        howToTitle: 'How to Collect Background Rewards',
        id: 'background-rewards',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360041941033',
        learnMoreDescription: '',
        name: 'Background Rewards',
        relatedFeatures: ['geomine', 'engaging-surveys'],
        video: '',
    },
    {
        category: 'Achieve',
        description: "Feelin' Lucky? Use the treasures from your adventures to join our in-app Sweepstakes! Available to US & UK players only at this time.",
        howTo3Steps: [
            'Click your COIN Total to open redemptions',
            'Tap "Sweepstakes" to view sweepstakes',
            'Enter 1, 10, or 100 Entries!',
        ],
        howToTitle: 'How to Enter a Sweepstakes',
        id: 'sweepstakes',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360058411214',
        learnMoreDescription: '',
        name: 'Sweepstakes',
        relatedFeatures: ['redeem-physical', 'redeem-digital'],
        video: '',
    },
    {
        category: 'Achieve',
        description: 'The digital world can be fun, but sometimes real-world prizes are even more fun. Trade in your treasure for shirts, gadgets, games, and more!',
        howTo3Steps: [
            'Click your COIN Total to open redemptions',
            'View Physical Redemption Options',
            'Redeem in the app!',
        ],
        howToTitle: 'How to Redeem for a Physical Item',
        id: 'redeem-physical',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360034008713',
        learnMoreDescription: '',
        name: 'Physical Redemptions',
        relatedFeatures: ['redeem-digital', 'geomine'],
        video: '',
    },
    {
        category: 'Achieve',
        description: "Love the idea of digital assets, collectibles, or souvenirs? We've got you.",
        howTo3Steps: ['Click your COIN Total to open redemptions', 'View Digital Redemption Options', 'Redeem in the app!'],
        howToTitle: 'How to Redeem for a Digital Item',
        id: 'redeem-digital',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360032792174',
        learnMoreDescription: '',
        name: 'Digital Redemptions',
        relatedFeatures: ['redeem-physical', 'geomine'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'New stores open, others may close, but with Rewarded Verifications, you can help make sure everyone knows!',
        howTo3Steps: [
            "Click the '+' menu in the top right",
            'Tap Rewarded Tasks, and then Rewarded Verifications.',
            'See available Rewarded Verifications near you, and follow the on-screen instructions.',
        ],
        howToTitle: 'How to Complete Rewarded Verifications',
        id: 'business-verifications',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/1500001541681',
        learnMoreDescription: '',
        name: 'Rewarded Verifications',
        relatedFeatures: ['engaging-surveys'],
        video: 'https://youtu.be/IL4ZOpKrvRU',
    },
    {
        category: 'Explore',
        description: 'Occasionally, you may find a super-treasure when you explore! Other times, you can validate the big wins of other players.',
        howTo3Steps: [
            "Big Geomines are random! But you can witness other players' Geomines!",
            'To witness, click the Big Geomine icon on the left side of your screen. (If available)',
            'Tap the checkmark to witness!',
        ],
        howToTitle: 'How to Witness Big Geomines',
        id: 'big-geomines',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360041640233',
        learnMoreDescription: '',
        name: 'Big Geomines',
        relatedFeatures: ['geomine', 'geoclaim'],
        video: '',
    },
    {
        category: 'Socialize',
        description: 'Pick a unique username, a fun profile picture, and climb your way to the top!',
        howTo3Steps: [
            'Click your COIN Total',
            'Tap the podium symbol in the top right',
            'To participate, tap the profile picture in the top left corner of the COIN app to set a username and profile picture.',
        ],
        howToTitle: 'How to View the Leaderboard',
        id: 'leaderboard',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360050283973',
        learnMoreDescription: '',
        name: 'Leaderboard',
        relatedFeatures: ['badges', 'easter-eggs'],
        video: '',
    },
    {
        category: 'Achieve',
        description: "You're experienced. You've grown up from your early Geominer days. Wear your badges with honor!",
        howTo3Steps: [
            'In the COIN app, you can collect secret badges and show these off to your friends.',
            'Badges hold no monetary value, they are purely for fun and bragging rights.',
            "We won't give hints on how to find these badges, that's part of the fun of earning them!",
        ],
        howToTitle: 'How to Earn & View Badges',
        id: 'badges',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360048287714',
        learnMoreDescription: '',
        name: 'In-App Badges',
        relatedFeatures: ['easter-eggs', 'leaderboard'],
        video: '',
    },
    {
        category: 'Explore',
        description: "Some users like illusions, using hacking to cheat. Extension Devices help prove you're authentic (plus they look neat!)",
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Activate an Extension Device',
        id: 'extension-devices',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360051088673',
        learnMoreDescription: '',
        name: 'Extension Devices',
        relatedFeatures: ['geomine', 'subscriptions'],
        video: 'https://www.youtube.com/watch?v=__-kJ2pXi60',
    },
    {
        category: 'Achieve',
        description: 'Just like interest in a bank, holding on to your treasures will increase your nest egg!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Collect HODL Rewards',
        id: 'hodl-rewards',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360035370314',
        learnMoreDescription: '',
        name: 'HODL Rewards',
        relatedFeatures: ['redeem-digital', 'geomine'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Geoclaiming allows other users to earn a percent of your COIN. Protect your rewards from their wandering eyes!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Activate Geoclaim Shield',
        id: 'geoclaim-shield',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360049715014',
        learnMoreDescription: '',
        name: 'Geoclaim Shield',
        relatedFeatures: ['geoclaim', 'remote-geoclaim'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Just want a little extra rewards? This power-up will give you a boost to Geoclaiming!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Activate Geoclaim Bonus',
        id: 'geoclaim-bonus',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360049715014',
        learnMoreDescription: '',
        name: 'Geoclaim Bonus',
        relatedFeatures: ['geeoclaim-shield', 'geoclaim'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Feeling like you want a little more out of COIN? You can purchase power-ups in bulk with Subscriptions! Watch your rewards sgrow. ',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Start a COIN Subscription',
        id: 'subscriptions',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360033324934',
        learnMoreDescription: '',
        name: 'Subscriptions',
        relatedFeatures: ['geoclaim-bonus', 'geomining-speed'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Geomining takes a few seconds to recharge. Level this feature up with Geomining Recharge rates!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Increase Geomining Recharge Rate',
        id: 'geomining-recharge',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360032756014',
        learnMoreDescription: '',
        name: 'Geomining Recharge',
        relatedFeatures: ['geomine', 'background-rewards'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Ever wished you could Geomine a liiiittle bit faster? Get that speed up!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Increase Geomining Speed',
        id: 'geomining-speed',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360032756014',
        learnMoreDescription: '',
        name: 'Geomining Speed',
        relatedFeatures: ['geomine', 'geomining-rate'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: "Background Rewards don't last forever. Increase your Background Time to receive rewards for a longer time. ",
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Increase Background Time',
        id: 'background-time',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360041941033',
        learnMoreDescription: '',
        name: 'Background Time',
        relatedFeatures: ['background-rewards', 'geomine'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Ever wanted to Geoclaim a rewarding region far away? Remote Geoclaim will get you there.',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Unlock Remote Geoclaim',
        id: 'remote-geoclaim',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360053865554',
        learnMoreDescription: '',
        name: 'Remote Geoclaim',
        relatedFeatures: ['geoclaim', 'geoclaim-shield'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Now, you can place a Geodrop wherever you want to!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Unlock Remote Geodrop',
        id: 'remote-geodrop',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360053865554',
        learnMoreDescription: '',
        name: 'Remote Geodrop',
        relatedFeatures: ['geodrop', 'leaderboard'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Remember Background Rewards? This power up recharges it even faster!',
        howTo3Steps: ['', '', ''],
        howToTitle: 'How to Increase Background Recharge Rate',
        id: 'background-recharge',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360041941033',
        learnMoreDescription: '',
        name: 'Background Recharge',
        relatedFeatures: ['remote-geoclaim', 'geomining-speed'],
        video: '',
    },
    {
        category: 'Power-Ups',
        description: 'Receive your Bonus Drops Faster!',
        howTo3Steps: ['You can upgrade the size of your Weekly Bonus Drop by simply using the app.', '', ''],
        howToTitle: 'How to Activate Bonus Drop Power Up',
        id: 'bonus-drop-power-up',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360053865554',
        learnMoreDescription: '',
        name: 'Bonus Drop Power Up',
        relatedFeatures: ['background-recharge', 'geomining-speed'],
        video: '',
    },
    {
        category: 'Explore',
        description: 'Been working hard? Enjoy some extra rewards, on us!',
        howTo3Steps: [
            'Bonus Drops are created and sent to your account automatically',
            'They are sent weekly, and the amount of COIN in each of these weekly Geodrops can vary daily.',
            'This Bonus Drop will appear for you each week in the form of a Geodrop.',
        ],
        howToTitle: 'How to Collect Bonus Drop',
        id: 'bonus-drop',
        learnMoreArticle: 'https://support.coinapp.co/hc/en-us/articles/360042841734',
        learnMoreDescription: '',
        name: 'Bonus Drop',
        relatedFeatures: ['geomine'],
        video: '',
    },
    {
        category: 'Achieve',
        description: "Well, you know we can't tell you much about these! ;)",
        howTo3Steps: [
            'An Easter Egg is a hidden message or feature in a game.',
            'The trick is to find them... no hints!',
            'Good Luck!',
        ],
        howToTitle: 'How to Unlock Easter Eggs',
        id: 'easter-eggs',
        learnMoreArticle: '',
        learnMoreDescription: '',
        name: 'Easter Eggs!',
        relatedFeatures: ['badges', 'leaderboard'],
        video: '',
    },
];
export default coinFeatureData;
